import { CheckInput, SelectInput, Svg } from '@smooved/ui';

export const realEstateAgentMoverProfileConsentOption: CheckInput<boolean> = {
    id: 'real-estate-agent-consent',
    name: 'real-estate-agent-consent',
    value: true,
    labelResource: 'REAL_ESTATE_AGENT.EOTS.OTHER_SERVICES.REAL_ESTATE_AGENT_CONSENT.MOVER_PROFILE',
};

export const serviceTelecom: CheckInput<boolean> = {
    id: 'other-services-telecom',
    svg: Svg.Telecom,
    labelResource: 'REAL_ESTATE_AGENT.EOTS.OTHER_SERVICES.OPTIONS.TELECOM',
    value: true,
    name: 'other-services-telecom',
};

export const requestWithoutMoverOptions: SelectInput<boolean>[] = [
    {
        id: 'request-side-by-side',
        svg: Svg.SideBySide,
        labelResource: 'REAL_ESTATE_AGENT.EOTS.OTHER_SERVICES.SIMULATION_TYPE.SIDE_BY_SIDE',
        value: false,
        name: 'request-type',
    },
    {
        id: 'request-solo',
        svg: Svg.Alone,
        labelResource: 'REAL_ESTATE_AGENT.EOTS.OTHER_SERVICES.SIMULATION_TYPE.SOLO',
        value: true,
        name: 'request-type',
    },
];
